import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/content";
import { Reveal, MaskLine, SectionLabel } from "./Reveal";

const ServiceRow = ({ s, i }) => (
  <Reveal
    as="li"
    delay={0.04 * i}
    className="group relative grid grid-cols-[auto_1fr] md:grid-cols-12 gap-x-5 md:gap-x-8 gap-y-3 py-9 sm:py-11 border-t border-white/15 last:border-b"
    data-testid={`service-row-${s.n}`}
  >
    <span className="absolute inset-y-0 -inset-x-5 sm:-inset-x-8 bg-white/[0.04] opacity-0 transition-opacity duration-500 group-hover:opacity-100 pointer-events-none" />
    <span className="font-display italic text-2xl sm:text-3xl text-[#B8874A] md:col-span-1">{s.n}</span>
    <h3 className="font-display text-2xl sm:text-3xl leading-snug text-white md:col-span-5 transition-transform duration-500 group-hover:translate-x-2">{s.title}</h3>
    <p className="col-start-2 md:col-start-auto md:col-span-4 text-[15px] leading-[1.8] text-white/70">{s.body}</p>
    <div className="col-start-2 md:col-start-auto md:col-span-2 flex md:justify-end items-start gap-3">
      <span className={`text-[10px] font-semibold tracking-[0.25em] uppercase px-3 py-1.5 border ${s.tag === "Coaching" ? "border-[#B8874A] text-[#D2A86E]" : "border-white/25 text-white/80"}`} data-testid={`service-tag-${s.n}`}>
        {s.tag}
      </span>
      <ArrowUpRight className="hidden md:block h-5 w-5 text-[#B8874A] opacity-0 -translate-x-2 transition-[opacity,transform] duration-500 group-hover:opacity-100 group-hover:translate-x-0" strokeWidth={1.25} />
    </div>
  </Reveal>
);

export const Services = () => (
  <section id="services" className="relative bg-[#16302B] text-white py-24 sm:py-32 lg:py-40 overflow-hidden grain" data-testid="services-section">
    <div className="absolute inset-0 hairline-grid pointer-events-none" />
    <div className="relative max-w-[1320px] mx-auto px-5 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-8">
          <Reveal><SectionLabel index="IV." dark>What I Help With</SectionLabel></Reveal>
          <h2 className="font-display mt-8 text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.12] tracking-[-0.015em]" data-testid="services-headline">
            <MaskLine inView>Six ways we can</MaskLine>
            <MaskLine inView delay={0.1} className="italic text-[#B8874A]">work together.</MaskLine>
          </h2>
        </div>
        <Reveal className="lg:col-span-4 text-[15px] leading-[1.8] text-white/70">
          Each draws on a distinct chapter of my own operating history — not a generic framework applied from the outside.
        </Reveal>
      </div>
      <ul className="mt-16">
        {SERVICES.map((s, i) => <ServiceRow key={s.n} s={s} i={i} />)}
      </ul>
    </div>
  </section>
);
